import React, { useEffect } from 'react';
import MaterialTabs, { tabsClasses } from '@mui/material/Tabs';
import { toSx } from '../../utils/sx';
import Tab, { tabClasses } from '@mui/material/Tab';
import Box, { boxClasses } from '@mui/material/Box';
import CardBase from 'components/Card/CardBase/CardBase';
import Stack from '@mui/material/Stack';
import { StringParam, useQueryParam } from 'use-query-params';

const BoxStyles = (theme) => ({
  root: {
    width: '100%',
    display: 'flex',
    backgroundColor: theme.vars.palette.background.tabs,
    borderRadius: '0.8rem',
    padding: '2px',
  },
});

const tabsStyles = (theme) => ({
  root: {
    backgroundColor: theme.vars.palette.background.tabs,
    borderRadius: '0.8rem',
    minHeight: 44,
    overflow: 'visible',
    width: '100%',
  },
  flexContainer: {
    position: 'relative',
    padding: '0 3px',
    zIndex: 1,
    overflow: 'visible',
  },
  indicator: {
    top: 2,
    bottom: 2,
    right: 3,
    height: 'auto',
    borderRadius: '8px',
    backgroundColor: theme.vars.palette.background.paper,
  },
  scroller: {
    paddingRight: '8px',
  },
})

const tabItemStyles = (theme) => ({
  root: {
    flexGrow: 1,
    minHeight: '4.8rem',
    opacity: 0.7,
    color: theme.vars.palette.text.primary,
    transitionProperty: 'color, opacity',
    transitionDuration: `${theme.transitions.duration.standard}ms}`,
    ...theme.typography.button,
    '&:hover': {
      opacity: 1,
    },
    [`&.${tabClasses.selected}`]: {
      color: `${theme.vars.palette.text.primary} !important`,
      opacity: 1,
    },
  },
})

function SimpleTabs({ items = [], queryParamName = 'tab' }) {
  const boxSx = toSx(BoxStyles, boxClasses);
  const tabItemSx = toSx(tabItemStyles, tabClasses);
  const tabsSx = toSx(tabsStyles, tabsClasses)

  // Получаем текущее значение параметра из URL
  const [tabQuery, setTabQuery] = useQueryParam(
    queryParamName,
    StringParam
  );

  // Определяем активную вкладку
  const activeValue = items.length > 0
    ? items.find(item => item.value === tabQuery)?.value || items[0]?.value
    : null;

  // Синхронизация параметра URL при изменении items
  useEffect(() => {
    if (items.length > 0 && !items.some(item => item.value === tabQuery)) {
      setTabQuery(items[0]?.value, 'replace');
    }
  }, [items, tabQuery, setTabQuery]);

  const handleTabChange = (_, value) => {
    setTabQuery(value);
  };

  return (
    <CardBase>
      <Stack
        direction="row"
        spacing={2}
        sx={{
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        {items.length > 0 && (
          <Box sx={boxSx}>
            <MaterialTabs
              value={activeValue || false}
              onChange={handleTabChange}
              sx={tabsSx}
            >
              {items.map(({ label, value }) => (
                <Tab
                  variant="button"
                  key={value}
                  disableRipple
                  label={label}
                  value={value}
                  sx={tabItemSx}
                />
              ))}
            </MaterialTabs>
          </Box>
        )}
      </Stack>
    </CardBase>
  );
}

export default SimpleTabs;